export const FEATURE_FLAGS = {
  USE_CAPTCHA: 'useCaptcha',
}
